module.exports = __webpack_public_path__ + "img/Intersect.2a76ce2f.png";